import { Button } from '@/components/base/button';
import CopyTool from '@/components/base/copytool';
import Section from '@/components/base/section';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InviteModal } from '../home/invite-modal';

export function ManageAffiliateCode({
  refcode,
}: {
  refcode: string;
}): JSX.Element {
  const [openInviteModal, setOpenInviteModal] = useState(false);

  const { t } = useTranslation();

  return (
    <Section variant="secondary" className="h-full">
      <div className="flex h-full  w-full flex-col gap-4">
        <div className="col-span-3 flex h-full w-full flex-col justify-between gap-4 md:col-span-2">
          <div className="flex w-full flex-col items-baseline justify-between sm:flex-row">
            <span>{t('affiliateDashboard.referralCodeTitle')}</span>

            <InviteModal
              isOpen={openInviteModal}
              onOpenChange={setOpenInviteModal}
            >
              <Button className="absolute right-6 top-3 h-fit w-fit justify-center truncate rounded-lg px-3 py-1.5 md:top-6 md:w-fit">
                {t('affiliateDashboard.invite.inviteUsers')}
              </Button>
            </InviteModal>
          </div>

          <div className="flex w-full flex-col gap-4">
            <CopyTool
              className="px-2 py-1.5"
              text={`https://partners.monevis.com/auth/registration?ref=${refcode}`}
            />
          </div>
        </div>
      </div>
    </Section>
  );
}
